module.exports = __webpack_public_path__ + "static/img/sutra02.2e8bba3.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/sutras/sutra02.png
// module id = mL3W
// module chunks = 3